import React from 'react'
import cn from 'classnames'
import {
  Button,
  type ButtonSizeValue,
  IconGiftDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { getPageEventName } from '@mc/pre-paywall-events'
import { track } from '@mc/track-event'
import { PROMO_I18N_NAMESPACE } from '../../lib/constants'
import styles from './GiftButton.module.scss'

interface GiftButtonProps {
  className?: string
  size?: ButtonSizeValue
  fullWidth?: boolean
  location: string
  href?: string
  onClick?: () => void
}

export const GiftButton = ({
  className = '',
  size = 'md',
  fullWidth = false,
  location,
  href = paths.gift,
  onClick,
}: GiftButtonProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <Button
      fullWidth={fullWidth}
      className={cn(
        'd-flex justify-content-center flex-gap-1',
        className,
        styles.alignItemsCenter,
      )}
      kind='tertiary'
      onClick={
        onClick ??
        (() => {
          // The gift link goes to /gift (upper funnel), so it must NOT fire
          // "Purchase Click". Instead fire the current
          // page's own click event (e.g. "Home Page Click", "Course Marketing
          // Click"), reusing the event name already used on each page.
          track(getPageEventName(), { action: 'Gift', location })
        })
      }
      render={
        // content is merged into this element at render time.
        <a href={href} />
      }
      size={size}
    >
      <IconGiftDefault size='sm' />
      {t('common.cta.secondary')}
    </Button>
  )
}
